/* PureEthical v30 - gaveta de filtros das colecoes.

   1. Tamanhos agrupados: letras (XS-3XL), numeros (calcado/calcas), jeans (cintura x comprimento),
      crianca (idades/meses) e outros. Antes vinham todos misturados numa so lista (ate 83 botoes).
      Grupos com muitos valores mostram os primeiros e um botao "Mostrar todos".
   2. Numero de resultados em direto: ao escolher filtros, o botao "Ver N produtos" passa a mostrar
      o numero real da selecao (antes mostrava sempre o total da colecao) e as contagens das outras
      opcoes acompanham. Na colecao Promocoes nao se aplica (pe-sale-only.js faz as contagens).
   3. URL limpo: nao envia campos vazios (preco sem valor) nem a ordenacao predefinida.
   Nao muda a forma como a Shopify filtra - so a apresentacao. */
(function () {
  var form = document.getElementById('pfdForm');
  if (!form) return;

  /* ---------- 1. tamanhos agrupados ---------- */
  var LET = ['xxxs', '3xs', 'xxs', '2xs', 'xs', 'xs/s', 's', 's/m', 'm', 'm/l', 'l', 'l/xl', 'xl', 'xxl', '2xl', 'xxxl', '3xl', '4xl', '5xl', '6xl',
             'tu', 'ts', 'os', 'uni', 'unico', 'único', 'unica', 'única', 'one size', 'taglia unica'];
  function bucket(v) {
    var t = String(v || '').trim(), lv = t.toLowerCase();
    if (/^w\s*\d+\s*l\s*\d+$/i.test(t)) return 'j';
    if (/^\d+(?:\s*[-–]\s*\d+)?\s*(a|m|y|anos|ans|mesi|meses)$/i.test(t) || /^\d+x$/i.test(t)) return 'k';
    if (/^\d+(?:[.,]\d+)?$/.test(t)) return 'n';
    if (LET.indexOf(lv) >= 0) return 'l';
    return 'o';
  }
  function num(v) { var m = String(v).match(/\d+(?:[.,]\d+)?/); return m ? parseFloat(m[0].replace(',', '.')) : 0; }
  function visible(lab) {
    var i = lab.querySelector('input');
    return !(i && i.disabled && !i.checked);
  }
  var SHOW = 12;
  var list = form.querySelector('.pfg[data-f="size"] .pfl');
  if (list && !list.getAttribute('data-pe-grouped')) {
    list.setAttribute('data-pe-grouped', '1');
    var B = { l: [], n: [], j: [], k: [], o: [] };
    [].slice.call(list.querySelectorAll('.pfo')).forEach(function (lab) {
      var inp = lab.querySelector('input');
      B[bucket(inp ? inp.value : '')].push(lab);
    });
    B.l.sort(function (a, b) {
      return LET.indexOf(a.querySelector('input').value.toLowerCase()) - LET.indexOf(b.querySelector('input').value.toLowerCase());
    });
    B.n.sort(function (a, b) { return num(a.querySelector('input').value) - num(b.querySelector('input').value); });
    B.j.sort(function (a, b) {
      var x = a.querySelector('input').value.match(/\d+/g) || [0, 0], y = b.querySelector('input').value.match(/\d+/g) || [0, 0];
      return (x[0] - y[0]) || (x[1] - y[1]);
    });
    B.k.sort(function (a, b) {
      var am = /m(eses|esi)?$/i.test(a.querySelector('input').value), bm = /m(eses|esi)?$/i.test(b.querySelector('input').value);
      if (am !== bm) return am ? -1 : 1;
      return num(a.querySelector('input').value) - num(b.querySelector('input').value);
    });
    var keys = ['l', 'n', 'j', 'k', 'o'].filter(function (k) { return B[k].some(visible); });
    var titled = keys.length > 1;
    list.innerHTML = '';
    keys.forEach(function (k) {
      if (titled) {
        var h = document.createElement('p');
        h.className = 'pe-szh';
        h.textContent = form.getAttribute('data-sz-' + k) || '';
        list.appendChild(h);
      }
      var w = document.createElement('div');
      w.className = 'pe-szg';
      var shown = 0, hidden = 0, hasHiddenChecked = false;
      B[k].forEach(function (lab) {
        w.appendChild(lab);
        if (!visible(lab)) return;
        shown++;
        if (shown > SHOW) {
          lab.classList.add('pe-sz-more');
          hidden++;
          if (lab.querySelector('input').checked) hasHiddenChecked = true;
        }
      });
      list.appendChild(w);
      if (hidden && !hasHiddenChecked) {
        w.classList.add('pe-sz-collapsed');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pe-sz-all';
        btn.textContent = (form.getAttribute('data-sz-more') || 'Mostrar todos') + ' (' + (shown) + ')';
        btn.addEventListener('click', function () { w.classList.remove('pe-sz-collapsed'); btn.parentNode.removeChild(btn); });
        list.appendChild(btn);
      }
    });
    var st = document.createElement('style');
    st.textContent =
      'html body .pfd .pfg[data-f="size"] .pfl{display:block!important}' +
      'html body .pfd .pe-szh{margin:14px 0 8px;font:600 10.5px/1.2 var(--pe-font-ui,Archivo,Arial,sans-serif);letter-spacing:.12em;text-transform:uppercase;color:#6B6B6B}' +
      'html body .pfd .pe-szh:first-child{margin-top:2px}' +
      'html body .pfd .pe-szg{display:flex;flex-wrap:wrap;gap:8px}' +
      'html body .pfd .pe-szg.pe-sz-collapsed .pe-sz-more{display:none!important}' +
      'html body .pfd .pe-sz-all{margin:10px 0 2px;padding:0;border:0;background:none;font:500 13px/1.3 var(--pe-font-ui,Archivo,Arial,sans-serif);color:#0A0A0A;text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
    document.head.appendChild(st);
  }

  /* ---------- 3. URL limpo ---------- */
  function params() {
    var fd = new FormData(form), sp = new URLSearchParams(), def = form.getAttribute('data-default-sort');
    fd.forEach(function (v, k) {
      v = String(v).trim();
      if (!v) return;
      if (k === 'sort_by' && v === def) return;
      sp.append(k, v);
    });
    return sp;
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = params().toString();
    location.href = ('/' + location.pathname.replace(/^\/+/, '')) + (q ? '?' + q : '');
  });

  /* ---------- 2. numero de resultados em direto ---------- */
  if (form.hasAttribute('data-pe-nolive')) return;
  var go = form.querySelector('.pfd-go'), sub = document.querySelector('.pfd-sub');
  var timer = null, seq = 0;
  function setNum(el, n) {
    if (!el) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), t;
    while ((t = w.nextNode())) {
      if (/\d/.test(t.nodeValue)) { t.nodeValue = t.nodeValue.replace(/\d[\d.\s ]*/, n + ' '); return; }
    }
  }
  function refresh() {
    var my = ++seq, q = params().toString();
    if (go) go.setAttribute('aria-busy', 'true');
    fetch(('/' + location.pathname.replace(/^\/+/, '')) + (q ? '?' + q : ''), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (my !== seq) return;
        var d = new DOMParser().parseFromString(html, 'text/html');
        var c = d.querySelector('.pfb-count'), m = c && c.textContent.match(/\d[\d.\s ]*/);
        var n = m ? m[0].replace(/[\s .]/g, '') : (d.querySelector('.pe-coll-empty') ? '0' : null);
        if (n !== null) { setNum(go, n); setNum(sub, n); }
        /* contagens e disponibilidade de cada opcao, segundo a nova selecao */
        var map = {};
        d.querySelectorAll('#pfdForm .pfo input[name]').forEach(function (i) {
          var lab = i.closest('.pfo'), cc = lab && lab.querySelector('.pfo-c');
          map[i.name + '\u0001' + i.value] = { c: cc ? cc.textContent : null, dis: i.disabled };
        });
        form.querySelectorAll('.pfo input[name]').forEach(function (i) {
          var rec = map[i.name + '\u0001' + i.value], lab = i.closest('.pfo'), cc = lab && lab.querySelector('.pfo-c');
          if (!rec) { if (!i.checked) { i.disabled = true; if (cc) cc.textContent = '0'; } return; }
          if (cc && rec.c !== null) cc.textContent = rec.c;
          i.disabled = rec.dis && !i.checked;
        });
      })
      .catch(function () {})
      .then(function () { if (my === seq && go) go.removeAttribute('aria-busy'); });
  }
  function later() { clearTimeout(timer); timer = setTimeout(refresh, 300); }
  form.addEventListener('change', later);
  form.querySelectorAll('.pfp input').forEach(function (i) { i.addEventListener('input', later); });
  form.querySelectorAll('.pfq-b').forEach(function (b) { b.addEventListener('click', function () { setTimeout(later, 0); }); });
})();
